import { isDraggingCalendarItem } from 'owa-calendar-surface-dategrid-common-dnd-callbacks';

export function canDropCalendarItem(): boolean {
    return isDraggingCalendarItem();
}
